var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#7BD3BD",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 45.581 45.581",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "circle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.619,9.923h-2.975c-2.188,0-3.945,1.76-3.945,3.948v5.977h-3.971v-5.977c0-2.188-1.785-3.948-3.974-3.948h-2.974 c-2.188,0-3.933,1.76-3.933,3.948v5.977h-4.807L13.95,1.302C13.907,0.565,13.298,0,12.56,0H7.22c-0.722,0-1.323,0.542-1.387,1.26 l-1.64,18.587H3.99c-2.203,0-3.99,1.756-3.99,3.959V41.59c0,2.203,1.787,3.99,3.99,3.99h37.601c2.203,0,3.99-1.787,3.99-3.99 v-27.72C45.581,11.684,43.807,9.923,41.619,9.923z M11.909,34.35c0,0.76-0.616,1.375-1.375,1.375H7.33 c-0.76,0-1.375-0.615-1.375-1.375v-3.203c0-0.76,0.615-1.375,1.375-1.375h3.204c0.76,0,1.375,0.615,1.375,1.375V34.35z  M21.833,34.35c0,0.76-0.616,1.375-1.375,1.375h-3.204c-0.759,0-1.375-0.615-1.375-1.375v-3.203c0-0.76,0.616-1.375,1.375-1.375 h3.204c0.759,0,1.375,0.615,1.375,1.375V34.35z M31.688,34.35c0,0.76-0.615,1.375-1.375,1.375h-3.203 c-0.76,0-1.375-0.615-1.375-1.375v-3.203c0-0.76,0.615-1.375,1.375-1.375h3.203c0.76,0,1.375,0.615,1.375,1.375V34.35z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiq);
export default __webpack_public_path__ + "static/media/RIQ.e2a9cf939bf81d630eb70e6d77db0343.svg";
export { ForwardRef as ReactComponent };